import CandidateAttachments from './CandidateAttachments.container';

export default CandidateAttachments;
